import React, {Fragment} from 'react';
import PropTypes from "prop-types";
import {currency_symbol} from '../../../server/constants';
import {convertTwoDecimalPoint, calculateStripeCharges, _addNotificationError,_addNotification} from '../../../server/util'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import instantCheckOut from './instantCheckOut'
import InstantCheckOut from './instantCheckOut';
const paymentMethods={
    cash:'Cash',
    check:'Check',
    creditCard:'Credit Card',
    onlinePayment:'Online Payment'
}
class InstantPayment extends React.Component{
    constructor(props){
        super(props);
        this.state={
            tabIndex:0,
            monthYear:'',
            lunchBal:{
                selected:true,
                balAvAmount:0.00,
                amount:0.00
            },
            paymentObj:{
                fullAmount:0.00,
                paidEditPrice:0.00,
                balAmount:0.00,
                charges:0.00,
                paymentType:'Cash',
                checkNum:'',
                showStripeBtn:false,
            },
            formData:[],
            isParent: (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN')?false:true,
        }
    }
    componentWillMount=()=>{
        this.setAmount(this.props);
    }
    componentWillReceiveProps=(nextProps)=>{
        this.setAmount(nextProps);    
    }
    setAmount=(data)=>{
        const {lunchBal,paymentObj}=this.state;
        lunchBal.balAvAmount=parseFloat(convertTwoDecimalPoint(data.lunchBal,2));
        paymentObj.fullAmount=parseFloat(convertTwoDecimalPoint(data.fullAmount,2));
        paymentObj.paidEditPrice=parseFloat(convertTwoDecimalPoint(data.paidEditPrice,2));
        this.setState({lunchBal:lunchBal, paymentObj:paymentObj, 
            formData:data.formData, monthYear:data.mealMonth},()=>{
            this.balToPay();
        });
    }
    balToPay=()=>{
        const {lunchBal,paymentObj}= this.state;
        let bToPay=paymentObj.fullAmount-paymentObj.paidEditPrice;
        if(bToPay<=0){
            lunchBal.selected=false;
            paymentObj.balAmount= bToPay; 
        }else{
            if(lunchBal.selected && lunchBal.balAvAmount>0){  
                let bal=(bToPay>lunchBal.balAvAmount)?(bToPay-lunchBal.balAvAmount):- (lunchBal.balAvAmount-bToPay);
                if(bal<0){
                    paymentObj.balAmount=0.00;
                    lunchBal.amount= bToPay;
                }else{
                    paymentObj.balAmount= bal;
                    lunchBal.amount= lunchBal.balAvAmount;
                }           
            }else{
                lunchBal.selected=false;
                lunchBal.amount=0.00;
                paymentObj.balAmount=bToPay;            
            }
        }    
        if(this.state.tabIndex===0 && this.state.isParent){
            let bal=0.00;
            if(lunchBal.selected){
             bal=(bToPay>lunchBal.balAvAmount)?(bToPay-lunchBal.balAvAmount):- (lunchBal.balAvAmount-bToPay);
            }else{
                bal=bToPay;
            }
            if(bal<=0){
                paymentObj.charges=0.00;
                paymentObj.showStripeBtn=false;
            }else{
                paymentObj.charges=calculateStripeCharges(bal,true, );
                paymentObj.paymentType='Online';
                paymentObj.balAmount=bal;
                paymentObj.showStripeBtn=true;
            }            
        }
        this.setState({paymentObj:paymentObj, lunchBal:lunchBal});
    }

    buildTabs=()=>{
        return(
            <Fragment>
            {
                this.walletSection()
            }    
            <div className="row">
                <div className="col-md-12">
                <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
                    <TabList>
                    {
                        !this.state.isParent?
                        <Fragment>
                            <Tab onClick={()=>{
                                const {paymentObj}=this.state;
                                paymentObj.paymentType="Cash";
                                paymentObj.checkNum="";
                                this.setState(paymentObj);
                            }}>{paymentMethods.cash}</Tab>
                            <Tab onClick={()=>{
                                const {paymentObj}=this.state;
                                paymentObj.paymentType="Check";
                                paymentObj.checkNum="";
                                this.setState(paymentObj);
                            }}>{paymentMethods.check}</Tab>
                            <Tab onClick={()=>{
                                const {paymentObj}=this.state;
                                paymentObj.paymentType="CreditCard";
                                paymentObj.checkNum="";
                                this.setState(paymentObj);
                            }}>{paymentMethods.creditCard}</Tab>
                        </Fragment>:null
                    }
                    {
                        this.state.isParent? <Tab>{paymentMethods.onlinePayment}</Tab>:null
                    }   
                    </TabList>
                    {
                        !this.state.isParent?
                        <Fragment>
                        <TabPanel>
                        {
                            this.state.paymentObj.paidEditPrice>0?
                            <div className="row">
                            <div className="col-md-8">
                                Paid Amount
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.paidEditPrice,2)}`}</span>
                            </div>
                        </div>:null
                        }
                        <div className="row">
                            <div className="col-md-8">
                                Amount to Pay
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.balAmount,2)}`}</span>
                            </div>
                        </div>
                        </TabPanel>
                        <TabPanel>
                        {
                            this.state.paymentObj.paidEditPrice>0?
                            <div className="row">
                            <div className="col-md-8">
                                Paid Amount
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.paidEditPrice,2)}`}</span>
                            </div>
                        </div>:null
                        }   
                        <div className="row">
                            <div className="col-md-5">
                                Amount to Pay
                            </div>
                            <div className="col-md-3">
                                <input type="text" className="form-control" value={this.state.paymentObj.checkNum} placeholder="Check No" onChange={(e)=>{
                                    const {paymentObj}=this.state;
                                    paymentObj['checkNum']=e.target.value;
                                    this.setState({paymentObj});
                                }} />
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.balAmount,2)}`}</span>
                            </div>
                        </div>
                        </TabPanel>
                        <TabPanel>
                        {
                            this.state.paymentObj.paidEditPrice>0?
                            <div className="row">
                            <div className="col-md-8">
                                Paid Amount
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.paidEditPrice,2)}`}</span>
                            </div>
                        </div>:null
                        }
                        <div className="row">
                            <div className="col-md-5">
                                Amount to Pay
                            </div>
                            <div className="col-md-3">
                                <input type="text" className="form-control" value={this.state.paymentObj.checkNum} placeholder="Ref No" onChange={(e)=>{
                                    const {paymentObj}=this.state;
                                    paymentObj['checkNum']=e.target.value;
                                    this.setState({paymentObj});
                                }} />
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.balAmount,2)}`}</span>
                            </div>
                        </div>
                        </TabPanel>
                        </Fragment>:null
                        }
                        {
                            this.state.isParent?
                        <TabPanel>
                        {
                            this.state.paymentObj.paidEditPrice>0?
                            <div className="row">
                            <div className="col-md-8">
                                Paid Amount
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.paidEditPrice,2)}`}</span>
                            </div>
                        </div>:null
                        }
                        <div className="row">
                            <div className="col-md-8">
                                Amount to Pay
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.balAmount,2)}`}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8">
                                Stripe Transaction charges
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.paymentObj.charges,2)}`}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <hr style={{margin:'10px 0px'}} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8">
                                Total Payment Amount
                            </div>
                            <div className="col-md-4 text-right">
                                <span className="label-text">{`${currency_symbol()} ${(parseFloat(convertTwoDecimalPoint(this.state.paymentObj.charges,2))+ parseFloat(convertTwoDecimalPoint(this.state.paymentObj.balAmount,2))).toFixed(2)}`}</span>
                            </div>
                        </div>
                        </TabPanel>:null
                        }                
                </Tabs>
                </div>
            </div>
                
            </Fragment>
        )
    }
    walletSection=()=>{
        return <div className="row">
            <div className="col-md-8">
                <div className="form-group">
                    <div className="checkbox">
                        <label>
                            <input type="checkbox" checked={this.state.lunchBal.selected} onChange={(e)=>{
                                let _lunchBal=this.state.lunchBal;
                                _lunchBal.selected=e.target.checked?true:false;
                                this.setState({lunchBal:_lunchBal},()=>{
                                    this.balToPay();
                                });
                            }} /><span className="label-text">Lunch Balance </span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="col-md-4 text-right">
                <span className="label-text">{`${currency_symbol()} ${convertTwoDecimalPoint(this.state.lunchBal.balAvAmount,2)}`}</span>
            </div>
        </div>    
    }
    showHideLoading=(isShow)=>{        
        this.setState({loading:isShow})        
}
onPaymentDone=(resp)=>{
    if(resp.statusCode==200){
        this.setState({loading: false});
        _addNotification(resp.statusMessage, this.props);
        setTimeout(() =>
            (sessionStorage.getItem('ROLE')=='ROLE_ADMIN'?
            this.context.router.history.push('/schoolAdmin/viewOrdersGrid')
            : window.location.replace('/parent')), 2000);    
        setTimeout(() =>            
        //this.props.history.push('/parent')
        window.location.replace('/parent')
        , 3000);    
    }else{
        this.setState({loading: false});
        _addNotificationError(resp.message, this.props)
        console.log('Meal order Creation Error', resp)
    }
}
    render(){
        const {lunchBal, paymentObj} =this.state;
        return (<Fragment>
            <div className='row'>
                <div className="col-md-12">
                {
                    this.buildTabs()
                }
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 text-left">
                    <button className="btn btn-danger" onClick={()=>{
                        this.props.onClickCancel();
                    }}>Cancel</button>
                </div>
                <div className="col-md-6 text-right">  
                    {
                        this.state.isParent && paymentObj.showStripeBtn ?
                        <InstantCheckOut formData={this.state.formData} 
                        lunchBal={lunchBal}
                        paidEditPrice={this.props.paidEditPrice}
                        paymentObj={paymentObj}
                        monthYear={this.state.monthYear} 
                        onPaymentDone={this.onPaymentDone} 
                        showHideLoading={this.showHideLoading} />:
                        <button className="btn btn-success" onClick={()=>{
                            const _monthYear=this.state.monthYear;
                            this.props.onAdminPaymentSubmit({lunchBal,paymentObj, _monthYear})
                        }}>Pay</button>
                    }            
                </div>
            </div>
        </Fragment>)
    }
}
InstantPayment.contextTypes = {
    router: PropTypes.object.isRequired
}

export default InstantPayment;


// WEBPACK FOOTER //
// ./src/components/Parent/OrderMeals/instantPayment.jsx